export default (settings: any) => settings['standardFilter'] * (10 / 60)
